exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SessionCard-module__top___156PC{display:grid;grid-template-columns:1fr auto;gap:1.25rem;align-items:center;margin-right:1rem}.SessionCard-module__top___156PC svg{cursor:pointer}.SessionCard-module__upload___1u9WO{display:none}.SessionCard-module__image-text___3Xo0b{font-size:14px;text-align:center;margin-bottom:.5rem}.SessionCard-module__description___Qby91{margin-bottom:1rem}.SessionCard-module__button-wrapper___2fOgQ{display:grid;grid-auto-flow:column;justify-content:center;gap:1rem}", ""]);

// exports
exports.locals = {
	"top": "SessionCard-module__top___156PC",
	"upload": "SessionCard-module__upload___1u9WO",
	"image-text": "SessionCard-module__image-text___3Xo0b",
	"description": "SessionCard-module__description___Qby91",
	"button-wrapper": "SessionCard-module__button-wrapper___2fOgQ"
};